const PARIS_THEME = "parisTheme"

const initialState = {
  parisTheme: true,
}

export const setParisTheme = bool => {
  return {
    type: PARIS_THEME,
    bool,
  }
}

export default (state = initialState, action) => {
  switch (action.type) {
    case PARIS_THEME:
      return Object.assign({}, state, {
        parisTheme: action.bool,
      })
    default:
      return state
  }
}
